import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TableForm from './index';
import { TableStatus } from '../../types';
import { useTableForm } from '../../hooks/useTableForm';
import { useTableData } from '../../hooks/useTableData';
import LoadingComponent from '../../../../../app/layout/LoadingComponent';
import ErrorComponent from '../../../../../app/layout/ErrorComponent';

export const TableFormContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurantId, tableId } = useParams<{
    restaurantId: string;
    tableId: string;
  }>();
  const [searchParams] = useSearchParams();
  const tableNumber = searchParams.get('tableNumber');

  const { handleFormSubmit, loading: submitLoading } = useTableForm(
    restaurantId!
  );
  const {
    table,
    loading: fetchLoading,
    error,
  } = useTableData(restaurantId!, tableId);

  const handleCancel = () => {
    navigate(`/manager/restaurants/${restaurantId}/restaurant-tables`);
  };

  if (fetchLoading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorComponent onPrimaryAction={handleCancel} />;
  }

  const defaultValues = tableId
    ? {
        restaurantId: restaurantId!,
        tableId: tableId,
        tableNumber: table?.tableNumber ?? 0,
        status: table?.status ?? TableStatus.Available,
        notes: table?.notes ?? null,
        capacity: table?.capacity ?? null,
      }
    : {
        restaurantId: restaurantId!,
        tableNumber: tableNumber ? Number(tableNumber) : 0,
        status: TableStatus.Available,
        notes: null,
        capacity: null,
      };

  return (
    <TableForm
      defaultValues={defaultValues}
      onCancel={handleCancel}
      loading={submitLoading}
      submitLabel={tableId ? t('common.update') : t('common.create')}
      tableId={tableId}
      onSubmit={handleFormSubmit}
    />
  );
};
